export default "/_next/static/chunks/fonts/pxiByp8kv8JHgFVrLEj6Z1JlFc-K-29c728e10b15ef13d864e5c568158062.woff2";